import nuskin from './namespace.js'; // import global namespace we can attach to
// doesnt export anything, so we can just import
import RunConfigService from './runConfigService.js';
import ShoppingContext from './shoppingContext.js';
import { getCachedConfigField } from '@nuskin/configuration-sdk';
import StickyHeaderStack from './stickyHeader.js';
import PersonalOfferStorageService from './personalOfferStorageService.js';
import SponsorStorageService from './sponsorStorageService.js';
import SitesSessionStorageService from './sitesSessionStorageService.js';
import equinoxLocalStorage from './local-storage/equinox.js';
import event from './event';
import TdcStrings from './tdcStrings';
import UrlService from './urlService';
import _ from 'lodash';
import '@nuskin/nuskinjquery';

let ECOM3_STORAGE_KEY = 'shopContext';
let ADREDIT_STORAGE_KEY = 'adrEdit';
window.productDetails = window.productDetails || {}; // todo get this off the global namespace
window.MOBILE_WIDTH_BREAKPOINT = 767;  // todo get this off the global namespace
//Must start false so if a tab is refreshed it isn't set to true without going active
let tabActive = false;
// ImageLoader definition
// todo so we put this image loader in here because we want to preload an image. The only place we use
// todo this is in topnav.jsp, for the navtitleimage, which are the images for
// todo 'About', 'Shop', 'Community', 'Join our Team'. Do we really need these?
function ImageLoader() {
    let imageSrcs = new Array();
    this.addImage = function (imageSrc) {
        imageSrcs.push(imageSrc);
    };
    $(function () {
        for (let x = 0; x < imageSrcs.length; x++) {
            new Image().src = imageSrcs[x];
        }
    });
}

function initTabListener() {
    window.onmouseover = function () {
        tabActive = true;
    };
    window.onmouseout = function () {
        tabActive = false;
    }
}

// Initializer definition
// todo This is the nuskin.util.Initializer. We use it to add multiple functions to an array, and execute them in
// order on the jquery dom ready event. We only use it 7 times in our codebase, should we just use the jquery
// dom ready function for this?
function Initializer() {
    let loadFunctions = new Array();
    let initFunctions = new Array();

    const onLoadEmpty = () => { };
    const onLoadReady = () => {
        for (let x = 0; x < loadFunctions.length; x++) {
            if (!loadFunctions[x].hasRun) {
                loadFunctions[x].hasRun = true;
                loadFunctions[x].loadFunction();
            }
        }
    };

    this.onLoad = onLoadEmpty;

    this.init = function (config) {
        RunConfigService.setRunConfig(config);
        console.log("Set runConfig to:", config);

        for (let x = 0; x < initFunctions.length; x++) {
            if (!initFunctions[x].hasRun) {
                initFunctions[x].hasRun = true;
                initFunctions[x].initFunction();
            }
        }
        equinoxLocalStorage.setLocalStorageFlag()
        console.log("Initialized system");
    };

    this.addOnLoad = function (loadFunction) {
        loadFunctions.push({ loadFunction: loadFunction, hasRun: false });
    };

    this.addOnInit = function (initFunction) {
        initFunctions.push({ initFunction: initFunction, hasRun: false });
    };

    // onLoad needs to wait until the following configMaps are loaded
    // before being called.
    const neededConfigMaps = ['Loyalty', 'Cart'];

    const isSubset = (array1, array2) => {
        return array2.every((element) => array1.includes(element));
    };

    const configCallback = (configs) => {
        if (Array.isArray(configs) && isSubset(configs, neededConfigMaps)) {
            event.unsubscribe(event.global.CS_CONFIG_SET, configCallback);
            this.onLoad = onLoadReady;
            this.onLoad();
        }
    };

    event.getValue(event.global.CS_CONFIG_SET, configCallback, true);
}

function getAdrEdit() {
    //TODO: move to shop
    let adrEdit = null;
    if (sessionStorage.getItem(ADREDIT_STORAGE_KEY) !== null) {
        adrEdit = sessionStorage.getItem(ADREDIT_STORAGE_KEY);
    }
    return adrEdit === 'null' ? null : adrEdit;
}

nuskin.util = {
    //default environment properties
    RunConfigService,
    SponsorStorageService,
    PersonalOfferStorageService,
    SitesSessionStorageService,
    ShoppingContext,
    countryCode: RunConfigService.getRunConfig().country || "US",
    languageCode: RunConfigService.getRunConfig().language || "en",
    useProfiles: false,
    redirectToDashboard: true,
    useBackOfficeDashboard: false,
    useBackOfficeDashboardRedirect: false,
    usePreferredCustomerRedirect: false,
    preferredCustomerRedirectURL: "",
    extendedAccountServiceCredentials: "",
    allowedLanguages: {},
    tc: {},
    //global objects and functions
    Initializer: new Initializer(),
    ImageLoader: new ImageLoader(), // todo this is only used in topnav.jsp in hello-ui - kill it?
    getLocaleUrl: UrlService.getLocaleUrl,
    getTdcStrings: TdcStrings.getStrings, //TODO: move this to shop
    isWCMDisabled: UrlService.isWCMDisabled,
    isAuthor: UrlService.isAuthor,
    isEcom3: function () {
        //TODO: move to shop
        if ($.cookie(ECOM3_STORAGE_KEY) == 'shopApp') {
            return false
        } else if (getAdrEdit()) {
            return false;
        } else {
            return true;
        }
    },
    stripHTML: function (string) {
        let div = document.createElement("div");
        div.innerHTML = string;
        return div.textContent || div.innerText || "";
    },

    isPersonalOffer: function () {
        //TODO: Move to shop
        return PersonalOfferStorageService.isPersonalOffer();
    },
    isSkinConsult: function () {
        //TODO: Move to shop
        let context = ShoppingContext.getShoppingContext()
        if (context) {
            context = ShoppingContext.getShoppingContext().context;
        }
        return context === ShoppingContext.SKIN_CONSULT
    },
    //TODO: Move to shop
    isMecommerceStoreFront: UrlService.isMeCommerceStorefront,
    isMecommerce: UrlService.isMeCommerce,
    allowAnonymousShopping: function () {
        //TODO: Move to shop
        return getCachedConfigField('allowAnonymousShopping');
    },
    setTestRunConfig: function () {
        RunConfigService.setBaseUrl("https://test.nuskin.com");
    },
    setDevRunConfig: function () {
        RunConfigService.setBaseUrl("https://dev.nuskin.com");
    },
    extractDomain: UrlService.extractDomain,
    determineHostURL: UrlService.extractHostURL,
    getSponsorId: function () {
        //TODO: Move to account
        let SPONSOR_ID_LENGTH = 10;
        let storedSponsorId = SponsorStorageService.getSponsor();
        let sponsorId;

        if (storedSponsorId) {
            sponsorId = storedSponsorId;
        }

        // Check pitch app if there is no sponsor.
        if (!sponsorId) {
            let personalOffer = PersonalOfferStorageService.getPersonalOffer();
            if (personalOffer) {
                sponsorId = personalOffer.sapId;
            }
        }

        // Set the sponsor id in local storage.
        if (!storedSponsorId && sponsorId && sponsorId.length === SPONSOR_ID_LENGTH) {
            SponsorStorageService.setSponsor(sponsorId);
        }

        return sponsorId;
    },
    getValue: function (obj, defaultValue) {
        try {
            if (typeof eval(obj) !== "undefined") {
                return eval(obj);
            }
            return defaultValue;
        } catch (e) {
            return defaultValue;
        }
    },
    getSiteConfig: function () {
        let SITECONFIG = "siteConfig";
        return nuskin.util.getValue(SITECONFIG, "{}");
    },
    getCurrentPageTitle: function () {
        let $titlePageName = $("title");
        if ($titlePageName.length > 0) {
            return $($titlePageName[0]).text();
        }

        return this.getCurrentPageName();
    },
    getCurrentPageName: function (url) {
        let currentPageName = "";
        if (!url) {
            url = document.URL;
        }
        if (url.indexOf("#") !== -1) {
            currentPageName = url.substring(0, url.indexOf("#")).split("/");
        } else {
            currentPageName = url.split("/");
        }
        let pageName = currentPageName[currentPageName.length - 1];
        return pageName.substring(0, pageName.indexOf("."));
    },
    sanitizeEmbeddedPage: function () {
        // Sanitize the embedded page and remove any style tags inside of them.
        $('.embeddedPage style').remove();
        $('.embeddedPage title').remove();
    },
    hideSpinnerOverlay: function () {
        //TODO: move to shop
        $('#shopSpinner').hide();
    },
    isPositionWithinElement: function (position, element) {
        let $element = $(element),
            elPos = $element.offset(),
            width = $element.outerWidth(),
            height = $element.outerHeight();

        let left = elPos.left,
            right = left + width,
            top = elPos.top,
            bottom = top + height;

        return (position.x >= left
            && position.x <= right
            && position.y >= top
            && position.y <= bottom);
    },
    isTabActive: function () {
        return tabActive;
    },
    cleanupURL: function (url) {
        if (url.indexOf("http") === -1 && url.indexOf(".") === -1) {
            url += ".html";
        }
        return url;
    },
    getSubdomain: function (url) {
        let subdomain;
        if (url) {
            subdomain = url.split('.')[0];
        } else {
            subdomain = window.location.hostname.split('.')[0];
        }
        if ((subdomain.indexOf('www') === 0) || (subdomain.indexOf('dev') === 0) || (subdomain.indexOf('test') === 0) || (subdomain.indexOf('stage') === 0)) {
            subdomain = null;
        }
        return subdomain;
    },
    addSelectorToURL: function (selector) {
        let currentURL = document.URL;
        if (currentURL.indexOf("." + selector + ".") !== -1) {
            return currentURL;
        }
        let parsedURL = currentURL.split(".html");
        return parsedURL[0] + "." + selector + ".html";
    },
    urlHasSelector: function (selector) {
        let hasSelector = false;
        location.pathname.split(".").forEach((item) => {
            if (item === selector) {
                hasSelector = true;
            }
        });

        return hasSelector;
    },
    MobileUtils: function () {
        'use strict';

        let cachedState = "none";

        let TRANSFORM_LIST = [
            'transform',
            '-webkit-transform',
            '-moz-transform',
            '-ms-transform',
            '-o-transform'
        ];


        // ---------------------------------------------
        //
        //        Define all public methods.
        //
        // ---------------------------------------------
        var publicMethods = {
            isPhoneGap: function () {
                return (document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1);
            },
            isAndroid: function () {
                return navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/mobile|Mobile/i);
            },
            isBlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/BB10; Touch/);
            },
            isIOS: function () {
                return navigator.userAgent.match(/iPad|iPhone|iPod/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) /* iPad OS 13 */;
            },
            isOpera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            isWindows: function () {
                return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/webOS/i);
            },
            isIE10: function () {
                return (navigator.userAgent.indexOf('MSIE 10') != -1);
            },
            isMobile: function () {
                return (publicMethods.isAndroid() || publicMethods.isBlackBerry() || publicMethods.isIOS() || publicMethods.isOpera() || publicMethods.isWindows());
            },
            // For phonegap applications we need to use either a full url or a relative path.  This will strip the / off the absolute path or build a full url with the domain
            checkPath: function (path, needsFullPath) {
                if (path && path.length > 0) {
                    if (this.isPhoneGap()) {
                        if (needsFullPath === true) {
                            if (!path.match(/^http/i)) {
                                return UrlService.getSiteUrl() + '/' + this.checkPath(path, false);
                            }
                        } else {
                            if (path.match(/^\//)) {
                                return path.substr(1);
                            }
                        }
                    } else {
                        if (!path.match(/^http/i) && !path.match(/\//)) {
                            return '/' + path;
                        }
                    }
                }
                return path;
            },
            getIEVersion: function () {
                let version = (navigator.userAgent.match(/(MSIE [0-9.a-z]+)/g));

                if (typeof String.prototype.trim !== 'function') {
                    String.prototype.trim = function () {
                        return this.replace(/^\s+|\s+$/g, '');
                    };
                }
                if (version && version.length > 0) {
                    return version[0].trim().replace('MSIE', '');
                } else {
                    return null;
                }
            },
            getScreenHeight: function () {
                return $(window).height();
            },
            getScreenWidth: function () {
                return $(window).width();
            },
            isAndroidBrowserTheNativeAndroidBrowser: function () {
                let nua = navigator.userAgent;
                return ((nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1) && !(nua.indexOf('Chrome') > -1));
            },
            isMobileLike: function () {
                let mobileSized = (publicMethods.getScreenWidth() <= MOBILE_WIDTH_BREAKPOINT);
                return (publicMethods.isMobile() ? true : false) || mobileSized;
            },
            getState: function () {
                if (cachedState == 'none') {
                    cachedState = getCurrentState();
                }

                return cachedState;
            },
            elementPositionInWindow: function (element) {
                let $element = $(element),
                    offset = $element.offset();

                if (offset) {
                    return this.positionRelativeToWindow(offset);
                } else {
                    return null;
                }
            },
            positionRelativeToWindow: function (position) {
                return {
                    top: position.top - $(window).scrollTop(),
                    left: position.left - $(window).scrollLeft()
                };
            },
            isPositionInWindow: function (position) {
                return (position.left >= 0 &&
                    position.left <= window.innerWidth &&
                    position.top >= 0 &&
                    position.top <= window.innerHeight);
            },
            isPartOfElementInWindow: function (element) {
                let origin = this.elementPositionInWindow(element);
                if (!origin) return false;

                let pt_bl = {
                        left: origin.left,
                        top: origin.top + $(element).outerHeight()
                    },
                    pt_br = {
                        left: origin.left + $(element).outerWidth(),
                        top: origin.top + $(element).outerHeight()
                    },
                    pt_tr = {
                        left: origin.left + $(element).outerWidth(),
                        top: origin.top
                    },
                    result = false;

                let points = [origin, pt_bl, pt_br, pt_tr];
                for (let idx = 0; idx < points.length; idx++) {
                    let test_pt = points[idx];

                    result = this.isPositionInWindow(test_pt);
                    if (result) {
                        result = true;
                    }
                }

                return result;
            },
            getTransform: function (element) {
                let $el = $(element),
                    transform = null;

                // Find the correct property
                for (let idx = 0; idx < TRANSFORM_LIST.length; idx++) {
                    let _value = $el.css(TRANSFORM_LIST[idx]);
                    if (_value) {
                        transform = _value;
                        break;
                    }
                }

                if (transform && transform !== 'none') {
                    let kind = null,
                        result = {
                            str: transform,
                            kind: undefined
                        };

                    if (transform.indexOf('matrix') != -1) {
                        let matrix = parseInt(transform.split(','));

                        result.kind = "matrix";
                        result.x = matrix[4];
                        result.y = matrix[5];

                    }
                    if (transform.indexOf('translateX') != -1) {
                        result.kind = "translateX";
                        result.x = parseInt(transform);
                    }
                    if (transform.indexOf('translateY') != -1) {
                        result.kind = "translateY";
                        result.y = parseInt(transform);
                    }

                    return result;
                } else {
                    return null;
                }

            },
            setTransform: function (element, options) {
                let $el = $(element),
                    str = '';

                if (options.x) {
                    str = str + 'translateX(' + options.x + ')';
                }
                if (options.y) {
                    str = str + 'translateY(' + options.y + ')';
                }

                $el.css({
                    'transform': str,
                    '-webkit-transform': str,
                    '-moz-transform': str,
                    '-ms-transform': str,
                    '-o-transform': str
                });
            },
            formatDateYYYYMMdd: function (dateObj) {
                // formats to YYYY-MM-DD
                let year = dateObj.getFullYear();
                let day = dateObj.getDate();
                let month = dateObj.getMonth() + 1;

                return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
            }
        };


        // ---------------------------------------------
        //
        //        Define all private methods.
        //
        // ---------------------------------------------
        function getCurrentState() {
            let mobileLike = publicMethods.isMobileLike(),
                _newState = mobileLike ? "mobile" : "desktop";

            return _newState;
        }

        function watchWindowSize() {
            $(window).resize(_.throttle(function () {
                let _newState = getCurrentState();

                if (_newState != cachedState) {
                    publishMobileStateChange(cachedState, _newState);
                    cachedState = _newState;
                }
            }, 100));
        }

        function publishMobileStateChange(oldState, newState) {
            let ev = {
                state: newState,
                oldState: oldState,
                screenWidth: publicMethods.getScreenWidth(),
                screenHeight: publicMethods.getScreenHeight()
            };
            $(document).trigger("mobileStateChange", [ev]);
        }

        function encodeUserAgentInDOM() {
            let doc = document.documentElement;
            doc.setAttribute('data-useragent', navigator.userAgent);
        }

        // In iOS, fixed position property becomes ignored when
        // the keyboard appears. So we need to switch StickyHeaders
        // to "absolute" positionin
        if (publicMethods.isIOS()) {
            let counter = 0,
                iOSFixInterval = null;

            let stickyFixFocus = _.throttle(function (ev) {
                StickyHeaderStack.absoluteMode = true;
                StickyHeaderStack.stackOffsetMobile = null;
            }, 1000);

            let stickyFixBlur = _.throttle(function (ev) {
                StickyHeaderStack.absoluteMode = false;
                StickyHeaderStack.stackOffsetMobile = '#header';
            }, 1000);

            let fixIOSInputs = function () {
                counter++;
                if (counter == 10) {
                    clearInterval(iOSFixInterval);
                }

                let $inputs = $('input');
                $inputs.off('focus', '**', stickyFixFocus);
                $inputs.off('blur', '**', stickyFixBlur);
                $inputs.focus(stickyFixFocus);
                $inputs.blur(stickyFixBlur);
            };
            $(document).ready(function () {
                fixIOSInputs();
                iOSFixInterval = setInterval(fixIOSInputs, 4000);
            });
        }

        // Bind the event once the document is ready
        $(document).ready(function () {
            encodeUserAgentInDOM();
            watchWindowSize();
        });

        return publicMethods;
    }(),
    Url: function () {
        'use strict';

        let HASH_BANG = '_hb_';

        // ---------------------------------------------
        //
        //        Define all public methods.
        //
        // ---------------------------------------------
        var publicMethods = {
            getProtocol: function (url) {
                let protocol = publicMethods.getUrlDetails(url).protocol;
                return protocol ? protocol : 'http:';
            },
            getHost: function (url) {
                return publicMethods.getUrlDetails(url).host;
            },
            getHostname: function (url) {
                return publicMethods.getUrlDetails(url).hostname;
            },
            getPort: function (url) {
                return publicMethods.getUrlDetails(url).port;
            },
            getQuery: function (url) {
                return getQueryString(url);
            },
            addParam: function (url, paramName, paramValue) {
                url += publicMethods.getNumberOfParameters(url) > 0 ? "&" : "?";
                return url + paramName + '=' + paramValue;
            },
            getParam: function (url, paramName) {
                let results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(url);
                if (results === null) {
                    return null;
                }
                else {
                    return results[1] || 0;
                }
            },
            getAllParams: function (url) {
                return publicMethods.getUrlDetails(url).params;
            },
            getNumberOfParameters: function (url) {
                return Object.keys(publicMethods.getAllParams(url)).length;
            },
            removeParam: function (url, paramName) {
                let startIndex = url.indexOf(paramName);
                let isFirstParam = url[startIndex - 1] === '?';

                // Do the remove if we have any parameters
                if (startIndex > -1 && (isFirstParam || url[startIndex - 1] === '&')) {
                    let endIndexOfParamValue = url.substring(startIndex).search('&') + startIndex;
                    let numberOfParameters = publicMethods.getNumberOfParameters(url);

                    // If we only have one parameter we set the ending index at the end of the url.
                    if (endIndexOfParamValue === startIndex - 1) {
                        endIndexOfParamValue = url.length;
                    }

                    // Remove the parameter
                    let lengthOfParameterToRemove = endIndexOfParamValue - (startIndex - 1);
                    let paramToRemove = url.substr(startIndex - 1, lengthOfParameterToRemove);

                    url = url.replace(paramToRemove, "");

                    // Replace the '&' with a '?' on the first param if we removed the first param.
                    if (isFirstParam && numberOfParameters > 1) {
                        url = url.substr(0, startIndex - 1) + '?' + url.substr(startIndex);
                    }
                }

                return url;
            },
            removeAllParams: function (url) {
                return url.split('?')[0];
            },
            getUrlDetails: function (url) {
                return parseURL(url);
            },
            encodeParameter: function (urlParam) {
                return encodeURIComponent(urlParam)
            },
            decodeParameter: function (urlParam) {
                return decodeURIComponent(urlParam)
            }
        };

        // ---------------------------------------------
        //
        //        Define all private methods.
        //
        // ---------------------------------------------
        function parseURL(url) {
            let parser = document.createElement('a');

            // Let the browser do the work
            parser.href = url;

            return {
                protocol: parser.protocol,
                host: parser.host,
                hostname: parser.hostname,
                port: parser.port,
                params: getQueryStringParams(url)
            };
        }

        function getQueryStringParams(uri) {
            let queryString = getQueryString(uri);
            let params = {};
            if (!queryString) return params;
            let get = queryString.split("&");

            for (let i = 0; i < get.length; i++) {
                let pair = get[i].split("=");
                params[pair[0]] = unescape(pair[1]);
            }

            return params;
        }

        function getQueryString(uri) {
            let queryString = null;
            if (uri) {
                let a = document.createElement("a");
                a.href = uri;
                queryString = a.search.substring(1);
            }
            else {
                queryString = window.location.search.substring(1)
            }
            return queryString;
        }

        return publicMethods;
    }()
};

/*	SWFObject v2.2 <http://code.google.com/p/swfobject/>
 is released under the MIT License <http://www.opensource.org/licenses/mit-license.php>
 */
// TODO: nuskin.util.swfobject does not comply with strict mode that karma or babel or systemjs turns on
//nuskin.util.swfobject=function(){var D="undefined",r="object",S="Shockwave Flash",W="ShockwaveFlash.ShockwaveFlash",q="application/x-shockwave-flash",R="SWFObjectExprInst",x="onreadystatechange",O=window,j=document,t=navigator,T=false,U=[h],o=[],N=[],I=[],l,Q,E,B,J=false,a=false,n,G,m=true,M=function(){var aa=typeof j.getElementById!=D&&typeof j.getElementsByTagName!=D&&typeof j.createElement!=D,ah=t.userAgent.toLowerCase(),Y=t.platform.toLowerCase(),ae=Y?/win/.test(Y):/win/.test(ah),ac=Y?/mac/.test(Y):/mac/.test(ah),af=/webkit/.test(ah)?parseFloat(ah.replace(/^.*webkit\/(\d+(\.\d+)?).*$/,"$1")):false,X=!+"\v1",ag=[0,0,0],ab=null;if(typeof t.plugins!=D&&typeof t.plugins[S]==r){ab=t.plugins[S].description;if(ab&&!(typeof t.mimeTypes!=D&&t.mimeTypes[q]&&!t.mimeTypes[q].enabledPlugin)){T=true;X=false;ab=ab.replace(/^.*\s+(\S+\s+\S+$)/,"$1");ag[0]=parseInt(ab.replace(/^(.*)\..*$/,"$1"),10);ag[1]=parseInt(ab.replace(/^.*\.(.*)\s.*$/,"$1"),10);ag[2]=/[a-zA-Z]/.test(ab)?parseInt(ab.replace(/^.*[a-zA-Z]+(.*)$/,"$1"),10):0}}else{if(typeof O.ActiveXObject!=D){try{var ad=new ActiveXObject(W);if(ad){ab=ad.GetVariable("$version");if(ab){X=true;ab=ab.split(" ")[1].split(",");ag=[parseInt(ab[0],10),parseInt(ab[1],10),parseInt(ab[2],10)]}}}catch(Z){}}}return{w3:aa,pv:ag,wk:af,ie:X,win:ae,mac:ac}}(),k=function(){if(!M.w3){return}if((typeof j.readyState!=D&&j.readyState=="complete")||(typeof j.readyState==D&&(j.getElementsByTagName("body")[0]||j.body))){f()}if(!J){if(typeof j.addEventListener!=D){j.addEventListener("DOMContentLoaded",f,false)}if(M.ie&&M.win){j.attachEvent(x,function(){if(j.readyState=="complete"){j.detachEvent(x,arguments.callee);f()}});if(O==top){(function(){if(J){return}try{j.documentElement.doScroll("left")}catch(X){setTimeout(arguments.callee,0);return}f()})()}}if(M.wk){(function(){if(J){return}if(!/loaded|complete/.test(j.readyState)){setTimeout(arguments.callee,0);return}f()})()}s(f)}}();function f(){if(J){return}try{var Z=j.getElementsByTagName("body")[0].appendChild(C("span"));Z.parentNode.removeChild(Z)}catch(aa){return}J=true;var X=U.length;for(var Y=0;Y<X;Y++){U[Y]()}}function K(X){if(J){X()}else{U[U.length]=X}}function s(Y){if(typeof O.addEventListener!=D){O.addEventListener("load",Y,false)}else{if(typeof j.addEventListener!=D){j.addEventListener("load",Y,false)}else{if(typeof O.attachEvent!=D){i(O,"onload",Y)}else{if(typeof O.onload=="function"){var X=O.onload;O.onload=function(){X();Y()}}else{O.onload=Y}}}}}function h(){if(T){V()}else{H()}}function V(){var X=j.getElementsByTagName("body")[0];var aa=C(r);aa.setAttribute("type",q);var Z=X.appendChild(aa);if(Z){var Y=0;(function(){if(typeof Z.GetVariable!=D){var ab=Z.GetVariable("$version");if(ab){ab=ab.split(" ")[1].split(",");M.pv=[parseInt(ab[0],10),parseInt(ab[1],10),parseInt(ab[2],10)]}}else{if(Y<10){Y++;setTimeout(arguments.callee,10);return}}X.removeChild(aa);Z=null;H()})()}else{H()}}function H(){var ag=o.length;if(ag>0){for(var af=0;af<ag;af++){var Y=o[af].id;var ab=o[af].callbackFn;var aa={success:false,id:Y};if(M.pv[0]>0){var ae=c(Y);if(ae){if(F(o[af].swfVersion)&&!(M.wk&&M.wk<312)){w(Y,true);if(ab){aa.success=true;aa.ref=z(Y);ab(aa)}}else{if(o[af].expressInstall&&A()){var ai={};ai.data=o[af].expressInstall;ai.width=ae.getAttribute("width")||"0";ai.height=ae.getAttribute("height")||"0";if(ae.getAttribute("class")){ai.styleclass=ae.getAttribute("class")}if(ae.getAttribute("align")){ai.align=ae.getAttribute("align")}var ah={};var X=ae.getElementsByTagName("param");var ac=X.length;for(var ad=0;ad<ac;ad++){if(X[ad].getAttribute("name").toLowerCase()!="movie"){ah[X[ad].getAttribute("name")]=X[ad].getAttribute("value")}}P(ai,ah,Y,ab)}else{p(ae);if(ab){ab(aa)}}}}}else{w(Y,true);if(ab){var Z=z(Y);if(Z&&typeof Z.SetVariable!=D){aa.success=true;aa.ref=Z}ab(aa)}}}}}function z(aa){var X=null;var Y=c(aa);if(Y&&Y.nodeName=="OBJECT"){if(typeof Y.SetVariable!=D){X=Y}else{var Z=Y.getElementsByTagName(r)[0];if(Z){X=Z}}}return X}function A(){return !a&&F("6.0.65")&&(M.win||M.mac)&&!(M.wk&&M.wk<312)}function P(aa,ab,X,Z){a=true;E=Z||null;B={success:false,id:X};var ae=c(X);if(ae){if(ae.nodeName=="OBJECT"){l=g(ae);Q=null}else{l=ae;Q=X}aa.id=R;if(typeof aa.width==D||(!/%$/.test(aa.width)&&parseInt(aa.width,10)<310)){aa.width="310"}if(typeof aa.height==D||(!/%$/.test(aa.height)&&parseInt(aa.height,10)<137)){aa.height="137"}j.title=j.title.slice(0,47)+" - Flash Player Installation";var ad=M.ie&&M.win?"ActiveX":"PlugIn",ac="MMredirectURL="+O.location.toString().replace(/&/g,"%26")+"&MMplayerType="+ad+"&MMdoctitle="+j.title;if(typeof ab.flashvars!=D){ab.flashvars+="&"+ac}else{ab.flashvars=ac}if(M.ie&&M.win&&ae.readyState!=4){var Y=C("div");X+="SWFObjectNew";Y.setAttribute("id",X);ae.parentNode.insertBefore(Y,ae);ae.style.display="none";(function(){if(ae.readyState==4){ae.parentNode.removeChild(ae)}else{setTimeout(arguments.callee,10)}})()}u(aa,ab,X)}}function p(Y){if(M.ie&&M.win&&Y.readyState!=4){var X=C("div");Y.parentNode.insertBefore(X,Y);X.parentNode.replaceChild(g(Y),X);Y.style.display="none";(function(){if(Y.readyState==4){Y.parentNode.removeChild(Y)}else{setTimeout(arguments.callee,10)}})()}else{Y.parentNode.replaceChild(g(Y),Y)}}function g(ab){var aa=C("div");if(M.win&&M.ie){aa.innerHTML=ab.innerHTML}else{var Y=ab.getElementsByTagName(r)[0];if(Y){var ad=Y.childNodes;if(ad){var X=ad.length;for(var Z=0;Z<X;Z++){if(!(ad[Z].nodeType==1&&ad[Z].nodeName=="PARAM")&&!(ad[Z].nodeType==8)){aa.appendChild(ad[Z].cloneNode(true))}}}}}return aa}function u(ai,ag,Y){var X,aa=c(Y);if(M.wk&&M.wk<312){return X}if(aa){if(typeof ai.id==D){ai.id=Y}if(M.ie&&M.win){var ah="";for(var ae in ai){if(ai[ae]!=Object.prototype[ae]){if(ae.toLowerCase()=="data"){ag.movie=ai[ae]}else{if(ae.toLowerCase()=="styleclass"){ah+=' class="'+ai[ae]+'"'}else{if(ae.toLowerCase()!="classid"){ah+=" "+ae+'="'+ai[ae]+'"'}}}}}var af="";for(var ad in ag){if(ag[ad]!=Object.prototype[ad]){af+='<param name="'+ad+'" value="'+ag[ad]+'" />'}}aa.outerHTML='<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"'+ah+">"+af+"</object>";N[N.length]=ai.id;X=c(ai.id)}else{var Z=C(r);Z.setAttribute("type",q);for(var ac in ai){if(ai[ac]!=Object.prototype[ac]){if(ac.toLowerCase()=="styleclass"){Z.setAttribute("class",ai[ac])}else{if(ac.toLowerCase()!="classid"){Z.setAttribute(ac,ai[ac])}}}}for(var ab in ag){if(ag[ab]!=Object.prototype[ab]&&ab.toLowerCase()!="movie"){e(Z,ab,ag[ab])}}aa.parentNode.replaceChild(Z,aa);X=Z}}return X}function e(Z,X,Y){var aa=C("param");aa.setAttribute("name",X);aa.setAttribute("value",Y);Z.appendChild(aa)}function y(Y){var X=c(Y);if(X&&X.nodeName=="OBJECT"){if(M.ie&&M.win){X.style.display="none";(function(){if(X.readyState==4){b(Y)}else{setTimeout(arguments.callee,10)}})()}else{X.parentNode.removeChild(X)}}}function b(Z){var Y=c(Z);if(Y){for(var X in Y){if(typeof Y[X]=="function"){Y[X]=null}}Y.parentNode.removeChild(Y)}}function c(Z){var X=null;try{X=j.getElementById(Z)}catch(Y){}return X}function C(X){return j.createElement(X)}function i(Z,X,Y){Z.attachEvent(X,Y);I[I.length]=[Z,X,Y]}function F(Z){var Y=M.pv,X=Z.split(".");X[0]=parseInt(X[0],10);X[1]=parseInt(X[1],10)||0;X[2]=parseInt(X[2],10)||0;return(Y[0]>X[0]||(Y[0]==X[0]&&Y[1]>X[1])||(Y[0]==X[0]&&Y[1]==X[1]&&Y[2]>=X[2]))?true:false}function v(ac,Y,ad,ab){if(M.ie&&M.mac){return}var aa=j.getElementsByTagName("head")[0];if(!aa){return}var X=(ad&&typeof ad=="string")?ad:"screen";if(ab){n=null;G=null}if(!n||G!=X){var Z=C("style");Z.setAttribute("type","text/css");Z.setAttribute("media",X);n=aa.appendChild(Z);if(M.ie&&M.win&&typeof j.styleSheets!=D&&j.styleSheets.length>0){n=j.styleSheets[j.styleSheets.length-1]}G=X}if(M.ie&&M.win){if(n&&typeof n.addRule==r){n.addRule(ac,Y)}}else{if(n&&typeof j.createTextNode!=D){n.appendChild(j.createTextNode(ac+" {"+Y+"}"))}}}function w(Z,X){if(!m){return}var Y=X?"visible":"hidden";if(J&&c(Z)){c(Z).style.visibility=Y}else{v("#"+Z,"visibility:"+Y)}}function L(Y){var Z=/[\\\"<>\.;]/;var X=Z.exec(Y)!=null;return X&&typeof encodeURIComponent!=D?encodeURIComponent(Y):Y}var d=function(){if(M.ie&&M.win){window.attachEvent("onunload",function(){var ac=I.length;for(var ab=0;ab<ac;ab++){I[ab][0].detachEvent(I[ab][1],I[ab][2])}var Z=N.length;for(var aa=0;aa<Z;aa++){y(N[aa])}for(var Y in M){M[Y]=null}M=null;for(var X in nuskin.util.swfobject){nuskin.util.swfobject[X]=null}nuskin.util.swfobject=null})}}();return{registerObject:function(ab,X,aa,Z){if(M.w3&&ab&&X){var Y={};Y.id=ab;Y.swfVersion=X;Y.expressInstall=aa;Y.callbackFn=Z;o[o.length]=Y;w(ab,false)}else{if(Z){Z({success:false,id:ab})}}},getObjectById:function(X){if(M.w3){return z(X)}},embedSWF:function(ab,ah,ae,ag,Y,aa,Z,ad,af,ac){var X={success:false,id:ah};if(M.w3&&!(M.wk&&M.wk<312)&&ab&&ah&&ae&&ag&&Y){w(ah,false);K(function(){ae+="";ag+="";var aj={};if(af&&typeof af===r){for(var al in af){aj[al]=af[al]}}aj.data=ab;aj.width=ae;aj.height=ag;var am={};if(ad&&typeof ad===r){for(var ak in ad){am[ak]=ad[ak]}}if(Z&&typeof Z===r){for(var ai in Z){if(typeof am.flashvars!=D){am.flashvars+="&"+ai+"="+Z[ai]}else{am.flashvars=ai+"="+Z[ai]}}}if(F(Y)){var an=u(aj,am,ah);if(aj.id==ah){w(ah,true)}X.success=true;X.ref=an}else{if(aa&&A()){aj.data=aa;P(aj,am,ah,ac);return}else{w(ah,true)}}if(ac){ac(X)}})}else{if(ac){ac(X)}}},switchOffAutoHideShow:function(){m=false},ua:M,getFlashPlayerVersion:function(){return{major:M.pv[0],minor:M.pv[1],release:M.pv[2]}},hasFlashPlayerVersion:F,createSWF:function(Z,Y,X){if(M.w3){return u(Z,Y,X)}else{return undefined}},showExpressInstall:function(Z,aa,X,Y){if(M.w3&&A()){P(Z,aa,X,Y)}},removeSWF:function(X){if(M.w3){y(X)}},createCSS:function(aa,Z,Y,X){if(M.w3){v(aa,Z,Y,X)}},addDomLoadEvent:K,addLoadEvent:s,getQueryParamValue:function(aa){var Z=j.location.search||j.location.hash;if(Z){if(/\?/.test(Z)){Z=Z.split("?")[1]}if(aa==null){return L(Z)}var Y=Z.split("&");for(var X=0;X<Y.length;X++){if(Y[X].substring(0,Y[X].indexOf("="))==aa){return L(Y[X].substring((Y[X].indexOf("=")+1)))}}}return""},expressInstallCallback:function(){if(a){var X=c(R);if(X&&l){X.parentNode.replaceChild(l,X);if(Q){w(Q,true);if(M.ie&&M.win){l.style.display="block"}}if(E){E(B)}}a=false}}}}();

//load environment properties script
// TODO $("head").load(nuskin.configuration.site + '/apps/global/services/properties.nuskin.util.js');

nuskin.util.Initializer.addOnInit(function () {
    $.ajax({
        type: 'GET',
        url: RunConfigService.getBaseUrl() + '/apps/global/services/properties.nuskin.util.js',
        async: false,
        cache: true,
        dataType: 'script'
    });

});

initTabListener();

export default nuskin.util;
